export const Transition = {
  ms100: '100ms ease-out',
  ms200: '200ms ease-out',
  ms300: '300ms ease-out',
  ms500: '500ms ease-out',
}
